import React, { useState, useEffect } from 'react';

function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstall(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setShowInstall(false);
    }
    setDeferredPrompt(null);
  };

  if (!showInstall) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 998,
        animation: 'slideUp 0.3s ease'
      }}
    >
      <button
        onClick={handleInstall}
        data-testid="install-pwa-btn"
        style={{
          background: 'linear-gradient(135deg, #FF6B9D, #C06EED)',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'pointer',
          boxShadow: '0 2px 10px rgba(255, 107, 157, 0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontFamily: "'IBM Plex Sans Arabic', sans-serif",
          opacity: 0.85
        }}
      >
        <span style={{ fontSize: '14px' }}>📲</span>
        تثبيت التطبيق
      </button>
    </div>
  );
}

export default InstallPWA;
